import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid2,
  IconButton,
  TextField,
  useTheme,
} from "@mui/material";
import * as React from "react";
import { IoMdClose } from "react-icons/io";
import { useNavigate, useParams } from "react-router-dom";
import { useUpdateFileUploadMutation } from "store/slices/apis/fileUploadSlice";

export default function ApproveFileComponent(props) {
  const { open, cancel, rowData, openNotification, refetch } = props;
  const theme = useTheme();
  const navigate = useNavigate();
  const { projectId } = useParams();
  const [comment, setComment] = React.useState("");

  const [updateFile, updateFileRes] = useUpdateFileUploadMutation();

  const handleApprove = () => {
    let formData = {
      Id: rowData?.id,
      Status: "Approve",
    };

    updateFile(formData);
  };

  React.useEffect(() => {
    if (updateFileRes?.isSuccess) {
      if (updateFileRes?.data?.status == "success") {
        openNotification(updateFileRes?.data?.message, "success");
        setComment("");
        cancel();
        refetch();
        navigate(`/projects/${projectId}/key-file/all-file`);
      } else {
        openNotification(updateFileRes?.data?.message, "error");
      }
    }
  }, [updateFileRes?.isSuccess]);
  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={cancel}
        disableEnforceFocus
        disableRestoreFocus
        aria-labelledby="draggable-dialog-title"
        fullWidth={true}
        maxWidth={"sm"}
      >
        <DialogTitle
          sx={{
            fontWeight: 500,
            fontSize: "20px",
            color: "#252525",
            paddingBottom: 0,
          }}
          id="draggable-dialog-title"
        >
          Approve
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={cancel}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          }}
        >
          <IoMdClose style={{ fontSize: "20px" }} />
        </IconButton>
        <DialogContent>
          <DialogContentText
            sx={{ fontWeight: 400, fontSize: "16px", color: "#474747" }}
          >
            <DialogContentText
              sx={{
                fontWeight: 400,
                fontSize: "16px",
                color: "#474747",
                marginBottom: "20px",
              }}
            >
              Are you sure you want to approve this request? This action is
              permanent.
            </DialogContentText>
            <TextField
              id="outlined-multiline-static"
              label="Comment (Optional)"
              name="Comment"
              multiline
              fullWidth
              value={comment}
              slotProps={{ inputLabel: { shrink: true } }}
              onChange={(event) => {
                setComment(event?.target?.value);
              }}
              variant="filled"
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {/* <Button
                        variant="outlined"
                        onClick={cancel}
                        sx={{
                            color: `${theme?.customSettings?.themeColor}`,
                            fontSize: '16px',
                            fontWeight: '500',
                            textTransform: 'none',
                            border: `1px solid ${theme?.customSettings?.themeColor}`
                        }}
                    >
                        Cancel
                    </Button> */}
          <Button
            variant="contained"
            onClick={handleApprove}
            loading={updateFileRes?.isLoading}
            sx={{
              backgroundColor: `${theme?.customSettings?.themeColor}`,
              color: "#fff",
              fontSize: "16px",
              fontWeight: "500",
              textTransform: "none",
            }}
          >
            Approve
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
